export default {
  "_documentation": {
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehlercode-Lokalisierung für die 1File WebClient Anwendung"])},
    "structure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Fehlercodes folgen dem Format X.Y.Z.N"])},
    "X": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rolle - 0=Admin, 1=User"])},
    "Y": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Service/Entity - 0=Recipient, 1=User, 2=Ticket, 3=RecipientList, 4=File, 5=Config"])},
    "Z": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Operation - 0=Create, 1=Read, 2=Update, 3=Delete, 4=Send, 5=Get, 6=Upload"])},
    "N": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variante - 0=Generic (Standard), 1+=Specific (Spezifische Fehlerfälle)"])},
    "usage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zugriff via errorCode.split('.') -> [X][Y][Z][N]"])},
    "example": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehlercode 1.0.0.1 -> User-Rolle, Recipient-Service, Create-Operation, Variante 1"])}
  },
  "0": {
    "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin-Rolle (X=0) - Fehler für Administrator-Operationen"])},
    "0": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RecipientService (Y=0)"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin-Empfänger-Operation fehlgeschlagen"])}
      }
    },
    "1": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UserService (Y=1)"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin-Benutzer-Operation fehlgeschlagen"])}
      },
      "5": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Operation (Z=5)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Berechtigung für Admin-Zugriff"])}
      }
    },
    "2": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TicketService (Y=2)"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin-Ticket-Operation fehlgeschlagen"])}
      }
    },
    "3": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RecipientListService (Y=3)"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin-Empfängerliste-Operation fehlgeschlagen"])}
      }
    },
    "4": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FileService (Y=4)"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin-Datei-Operation fehlgeschlagen"])}
      }
    },
    "5": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ConfigService (Y=5)"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin-Konfiguration-Operation fehlgeschlagen"])}
      },
      "2": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Operation (Z=2)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nur Administratoren können Konfiguration ändern"])}
      }
    }
  },
  "1": {
    "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User-Rolle (X=1) - Fehler für Standard-Benutzer-Operationen"])},
    "0": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RecipientService (Y=0) - Verwaltung von Empfängern"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0) - Empfänger erstellen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger konnte nicht erstellt werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger ist bereits vorhanden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger Validierung fehlgeschlagen"])}
      },
      "1": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read Operation (Z=1) - Empfänger lesen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger konnte nicht abgerufen werden"])}
      },
      "2": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Operation (Z=2) - Empfänger aktualisieren"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger konnte nicht aktualisiert werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger Validierung fehlgeschlagen"])}
      },
      "3": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Operation (Z=3) - Empfänger löschen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger konnte nicht gelöscht werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger wird noch verwendet"])}
      },
      "4": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send Operation (Z=4) - Email senden"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger Email konnte nicht versendet werden"])}
      },
      "5": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Operation (Z=5) - Empfänger abrufen/suchen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger nicht gefunden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Empfänger gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ungültiger Suchfilter"])}
      }
    },
    "1": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UserService (Y=1) - Verwaltung von Benutzern"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0) - Benutzer erstellen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer konnte nicht erstellt werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer existiert bereits"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer Validierung fehlgeschlagen"])}
      },
      "1": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read Operation (Z=1) - Benutzer lesen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer konnte nicht abgerufen werden"])}
      },
      "2": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Operation (Z=2) - Benutzer aktualisieren"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer konnte nicht aktualisiert werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer Validierung fehlgeschlagen"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Berechtigung zum Aktualisieren"])}
      },
      "3": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Operation (Z=3) - Benutzer löschen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer konnte nicht gelöscht werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Berechtigung zum Löschen"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer hat aktive Ressourcen"])}
      },
      "4": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send Operation (Z=4) - Email senden"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer Email konnte nicht versendet werden"])}
      },
      "5": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Operation (Z=5) - Benutzer abrufen/suchen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer nicht gefunden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Benutzer gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ungültiger Suchfilter"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Berechtigung zum Abrufen"])}
      }
    },
    "2": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TicketService (Y=2) - Verwaltung von Tickets"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0) - Ticket erstellen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket konnte nicht erstellt werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket Validierung fehlgeschlagen"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei nicht gefunden für Ticket"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger nicht gefunden für Ticket"])},
        "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ungültiger Ticket-Typ"])},
        "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statisches Ticket benötigt Datei"])}
      },
      "1": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read Operation (Z=1) - Ticket lesen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket konnte nicht abgerufen werden"])}
      },
      "2": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Operation (Z=2) - Ticket aktualisieren"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket konnte nicht aktualisiert werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket Validierung fehlgeschlagen"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket ist abgelaufen"])},
        "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket Versuche aufgebraucht"])}
      },
      "3": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Operation (Z=3) - Ticket löschen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket konnte nicht gelöscht werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket nicht gefunden"])}
      },
      "4": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send Operation (Z=4) - Ticket Email (erneut) senden"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket Email konnte nicht erneut versendet werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statische Tickets sollen V2 API benutzen"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger Email ungültig"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mail-Service nicht verfügbar"])},
        "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Empfänger für Ticket gefunden"])}
      },
      "5": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Operation (Z=5) - Ticket abrufen/suchen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket nicht gefunden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Tickets gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ungültiger Suchfilter"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket ist abgelaufen"])},
        "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ticket Versuche aufgebraucht"])}
      }
    },
    "3": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RecipientListService (Y=3) - Verwaltung von Empfängerlisten"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0) - Empfängerliste erstellen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste konnte nicht erstellt werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste existiert bereits"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste Validierung fehlgeschlagen"])}
      },
      "1": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read Operation (Z=1) - Empfängerliste lesen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste konnte nicht abgerufen werden"])}
      },
      "2": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Operation (Z=2) - Empfängerliste aktualisieren"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste konnte nicht aktualisiert werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste Validierung fehlgeschlagen"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger nicht gefunden"])},
        "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger bereits in Liste"])}
      },
      "3": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Operation (Z=3) - Empfängerliste löschen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste konnte nicht gelöscht werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste wird noch verwendet"])}
      },
      "4": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send Operation (Z=4) - Email an Empfängerliste senden"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste Email konnte nicht versendet werden"])}
      },
      "5": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Operation (Z=5) - Empfängerliste abrufen/suchen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfängerliste nicht gefunden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Empfängerlisten gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ungültiger Suchfilter"])}
      }
    },
    "4": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FileService (Y=4) - Verwaltung von Dateien"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0) - Datei erstellen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei konnte nicht erstellt werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei existiert bereits"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei Validierung fehlgeschlagen"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei zu groß"])},
        "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ungültiger Dateityp"])}
      },
      "1": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read Operation (Z=1) - Datei lesen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei konnte nicht abgerufen werden"])}
      },
      "2": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Operation (Z=2) - Datei aktualisieren"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei konnte nicht aktualisiert werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei Validierung fehlgeschlagen"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei ist schreibgeschützt"])}
      },
      "3": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Operation (Z=3) - Datei löschen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei konnte nicht gelöscht werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei wird noch verwendet"])}
      },
      "4": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send Operation (Z=4) - Datei per Email senden"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei Email konnte nicht versendet werden"])}
      },
      "5": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Operation (Z=5) - Datei abrufen/suchen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei nicht gefunden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Dateien gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ungültiger Suchfilter"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei DeleteDate konnte nicht erneuert werden"])}
      },
      "6": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload Operation (Z=6) - Datei hochladen (Chunked Upload)"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei Upload ist fehlgeschlagen"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei Upload ist nicht abgeschlossen"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei Upload Abschluss ist fehlgeschlagen"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datei Upload Abbruch ist fehlgeschlagen"])},
        "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload Session nicht gefunden"])},
        "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload Block fehlgeschlagen"])},
        "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload Session abgelaufen"])},
        "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speicherplatz nicht ausreichend"])},
        "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blob-Speicher nicht verfügbar"])}
      }
    },
    "5": {
      "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ConfigService (Y=5) - Verwaltung von Konfigurationen"])},
      "0": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Operation (Z=0) - Konfiguration erstellen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfiguration konnte nicht erstellt werden"])}
      },
      "1": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read Operation (Z=1) - Konfiguration lesen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfiguration konnte nicht abgerufen werden"])}
      },
      "2": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Operation (Z=2) - Konfiguration aktualisieren"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfiguration konnte nicht aktualisiert werden"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfiguration nicht gefunden"])},
        "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfiguration Validierung fehlgeschlagen"])},
        "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Berechtigung zum Aktualisieren"])}
      },
      "3": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Operation (Z=3) - Konfiguration löschen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfiguration konnte nicht gelöscht werden"])}
      },
      "5": {
        "_comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Operation (Z=5) - Konfiguration abrufen/suchen"])},
        "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konfiguration nicht gefunden"])}
      }
    }
  }
}